import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import useConfig from './Config';
import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';
import {
    convertDateToIsoType,
    getDayWithWeekName,
    getMonthNameWithYear,
    monthDiff
} from '../../../utils/dateTimeUtil';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const Chart = ({ isFormStatistics = false }) => {
    const { options } = useConfig({ isFormStatistics });
    const patientData = useSelector((state) => state.statistics.patientStatistics);
    const formData = useSelector((state) => state.statistics.formStatistics);
    const patientRangeDate = useSelector((state) => state.statistics.patientRangeDate);
    const formRangeDate = useSelector((state) => state.statistics.formRangeDate);
    const statisticsData = isFormStatistics ? formData : patientData;
    const rangeDate = isFormStatistics ? formRangeDate : patientRangeDate;
    const diff = monthDiff(rangeDate?.start, rangeDate?.end);

    const labels = statisticsData?.map((item) => {
        if (diff > 3) {
            const result = convertDateToIsoType(item.date);
            return getMonthNameWithYear(result);
        } else {
            return getDayWithWeekName(item.date);
        }
    });
    // const uniqueLabels = [...new Set(labels)];
    const data = {
        labels,
        datasets: [
            {
                label: 'Dataset 1',
                data: statisticsData?.map((item) => item.count),
                backgroundColor: '#509ffa',
                hoverBackgroundColor: '#416ce1',
                borderRadius: '5',
                // barPercentage: 0.5,
                // barThickness: 6,
                maxBarThickness: 36
            }
        ]
    };

    return (
        <div style={{ width: '100%' }}>
            <Bar options={options} data={data} height="350" />
        </div>
    );
};
Chart.propTypes = {
    isFormStatistics: PropTypes.bool
};

export default Chart;
